<template>
    <a
        href="#"
        tabindex="-1"
        class="m-0 ms-2 text-warning-emphasis small"
    >
        <IconComp icon="fa-question-circle" />
    </a>
</template>
<script lang="ts" setup>
import { IconComp } from '@/components';
</script>
